import { faPen } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage, defineMessage, useIntl } from 'react-intl';

import { FontAwesomeIcon } from 'atoms/icons';
import { Tooltip } from 'atoms/tooltip/Tooltip';
import { LabelM } from 'atoms/typography';

import { LineupActionCta } from '../LineupActionCta';

type Props = {
  onTrack?: () => void;
  editUrl: string;
};

const message = defineMessage({
  id: 'Lobby.LineupActions.Tooltip.Edit',
  defaultMessage: 'Edit your lineup',
});

export const EditCta = ({ onTrack, editUrl }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <Tooltip
      title={
        <LabelM>
          <FormattedMessage {...message} />
        </LabelM>
      }
      placement="top-end"
    >
      <LineupActionCta
        color="tertiary"
        to={editUrl}
        onClick={onTrack}
        aria-label={formatMessage(message)}
      >
        <FontAwesomeIcon icon={faPen} />
      </LineupActionCta>
    </Tooltip>
  );
};
